module.exports = __webpack_public_path__ + "img/close.ed233f02.svg";